import React from "react";
import { useTranslation } from "react-i18next";
import logo from "./../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import Layout from "../../../Components/layout";
import ErrorMssg from "../../../Components/ErrorMssg/ErrorMssg";
import { useLibyaSignupLogic } from "./useLibyaSignupLogic";

const LibyaSignup = () => {
  const { t } = useTranslation();
  const {
    errMsg,
    msisdn,
    otp,
    setOtp,
    isOTP,
    setIsOTP,
    isLoading,
    isValidMsisdn,
    onSubmit,
    onVerifyOtp,
    allowOnlyNumbers,
    handleMsisdnChange,
  } = useLibyaSignupLogic();

  return (
    <Layout>
      <div className="sign-up w-100">
        {!isOTP && (
          <div className="bg-trans p-4 mx-md-auto col-md-6">
            <div className="logo text-center">
              <img className="servImg cptpl_logo" src={logo} alt="" />
            </div>

            <div className="text-center">
              <span className="main_span d-block">{t("SubscribeNowText")}</span>
              <span className=" cptpl_service d-block">
                {t(
                  "compete in tournaments and track their performance through leaderboards. It offers a space for both casual and competitive players across various games."
                )}
              </span>
            </div>

            <form onSubmit={onSubmit}>
              <div className="d-flex gap-2" dir="ltr">
                <input
                  value="218"
                  readOnly
                  className="form-control"
                  style={{ width: 55 }}
                />

                <input
                  type="text"
                  placeholder={t("Enteryourmobilenumber")}
                  className="form-control"
                  value={msisdn}
                  onChange={handleMsisdnChange}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              </div>

              {msisdn.length > 0 && !isValidMsisdn && (
                <small style={{ color: "#dc3545" }}>
                  {msisdn.startsWith("218")
                    ? t("Mobile number must be 12–13 digits when starting with 218")
                    : t("Mobile number must be 9 digits")}
                </small>
              )}

              <button
                className="btn w-100 mt-3 cptpl_subscribe"
                id="cta_button"
                disabled={isLoading || !isValidMsisdn}
                style={{
                  border: "2px solid #0d6efd",
                  borderRadius: "8px",
                  background: isValidMsisdn ? "#24627f" : "#2b799d",
                  fontWeight: 500,
                  transition: "all 0.3s ease",
                  opacity: isLoading || !isValidMsisdn ? 0.9 : 1,
                  cursor: isLoading || !isValidMsisdn ? "not-allowed" : "pointer",
                  color: "#fff",
                }}
              >
                {isLoading ? t("Processing") : t("subscribe")}
              </button>
            </form>

            <div className="mt-4" style={{ textAlign: "center" }}>
              <p
                className="price_text price_title cptpl_price"
                style={{ direction: "rtl" }}
              >
                {t("New_subscribers_weekly_ts_libyaF")}
                <br />
                {t("New_subscribers_monthly_ts_libyaF")}
              </p>

              <p className="cptpl_terms" style={{ direction: "rtl" }}>
                {t("New_subscribers_ts_libya_condition")}
              </p>
              <h6>
                <a href="/terms" className="text-decoration-none   me-2">
                  {t("terms_of_service")}
                </a>
                |
                <a href="/privacy" className="text-decoration-none  ms-2">
                  {t("privacy_policy")}
                </a>
              </h6>
            </div>
          </div>
        )}

        {isOTP && (
          <div className="bg-trans p-4 mx-md-auto col-md-6">
            <h3 className="text-center">
              <b>{t("OTP VERIFICATION")}</b>
            </h3>

            <p className="text-center">
              {t("Enter the OTP sent to")} - <b>{msisdn}</b>
            </p>

            <form onSubmit={onVerifyOtp}>
              <input
                className="form-control text-center"
                maxLength="4"
                placeholder={t("EnteryourOTP")}
                value={otp}
                onKeyDown={allowOnlyNumbers}
                onChange={(e) => setOtp(e.target.value)}
              />

              <button
                className="btn btn-sub w-100 mt-4"
                style={{
                  border: "2px solid #0d6efd",
                  borderRadius: "8px",
                  fontWeight: 500,
                  backgroundColor: "#2b799d",
                  color: "#fff",
                  transition: "all 0.3s ease",
                }}
                disabled={isLoading || otp.length !== 4}
              >
                {isLoading ? "..." : t("Confirm")}
              </button>

              <button
                type="button"
                className="btn back w-100 mt-3"
                style={{
                  border: "2px solid #0d6efd",
                  borderRadius: "8px",
                  fontWeight: 500,
                  transition: "all 0.3s ease",
                }}
                onClick={() => setIsOTP(false)}
              >
                {t("Back")}
              </button>
            </form>
          </div>
        )}
        <div className="w-100 d-flex justify-content-center">
          <div className="w-50">{errMsg ? <ErrorMssg errMsg={errMsg} /> : ""}</div>
        </div>
      </div>
    </Layout>
  );
};

export default LibyaSignup;
